<template>
  <div o-Container o-Container-App>
    <div class="debug" v-if="debugModel">
      <!-- <div class="containerMask"></div>-->
      <!-- 小程序登陆跳转，根据type跳转家长端（防疫人员端）、教师端（部委端）-->
      <!--  <div v-for="data in param">-->
      <!--  {{JSON.stringify(data)}}-->
      <!--  </div>-->
      <div>
        <b>isApplet：</b>{{isApplet}}<br/>
        <b>isLogin：</b>{{isLogin}}<br/>
        <b>isBangs：</b>{{octopus.passport.bangs}}<br/>
        <b>loginType：</b>{{octopus.passport.typeID==2?"家长":"教师"}} - {{octopus.passport.realName}}<br/>
        <!-- passport：{{JSON.stringify(octopus.passport)}}<br/> -->
        <b>campus: </b>{{octopus.passport.campus}}
        <br/>
        <b>Url：</b>{{url}}
        <br/>
        <!-- 模拟参数-->
        <input v-model="JSON.stringify(param)" AUTOCOMPLETE="off"/>
        <span @click="simulationLogin">[模拟提交]</span>
        <br/>
        <button v-on:click="getPhoto">拍照片</button>
        <button v-on:click="getNetwork">网络</button>
        <button v-on:click="getQRCode">二维码</button>
        <button v-on:click="getLocation">获取位置</button>
        <button v-on:click="getNavigation">打开导航</button>
        <button v-on:click="getShare">分享朋友圈</button>
        <button v-on:click="getQuit">退出</button>
        <b>signatureSource：</b>{{signatureSource}}
      </div>
    </div>
    <div class="load" v-if="!isLogin">
      <div class="picture"></div>
      <div class="content">
        <div class="text">拼命加载中...</div>
        <div class="progress">
          <el-progress :text-inside="true" :stroke-width="26" :percentage="progress" status="success"></el-progress>
        </div>
      </div>
    </div>
    <div class="home" v-if="isLogin">
      <o-head-tools></o-head-tools>
      <o-home-parent v-if="octopus.passport.typeID== 2 ? true:false"
                     v-on:callHomeComplete="onHomeComplete"></o-home-parent>
      <o-home-teacher v-if="octopus.passport.typeID== 1 ? true:false"
                      v-on:callHomeComplete="onHomeComplete"></o-home-teacher>
      <o-app-menu-campus></o-app-menu-campus>
    </div>
  </div>
</template>
<!-- 样式需要直接指定，否则加载会有一个时间过度 -->
<style scoped>
  [o-Container-App] {background: #ffffff;}
  [o-Container-App] .load {text-align: center;margin: auto;width: 100%;}
  [o-Container-App] .load .picture {margin: 40% 0 0 0;}
  [o-Container-App] .load .picture {display: inline-block;height: 200px;width: 240px;background: url('/static/skin/default/main/app/campus/login/img/load.png');background-size: 100%;}
  [o-Container-App] .text {}
  [o-Container-App] .content {text-align: center;margin: auto;width: 100%;}
  [o-Container-App] .content .text {color: #0A1655;font-family: 微软雅黑;font-size: 27px;margin: 10% 0 5% 0;}
  [o-Container-App] .content .progress {width: 80%;display: inline-block;}
  [o-Container-App] .debug {position: absolute;border-bottom: 1px solid #717172;width: 100%;color: #282829;z-index: 7777;background: white;opacity: 0.7;margin: 60px 0 0 0;}
</style>
<script>
  import oHomeParent from '@/components/APP/Campus/Home/ParentHome';
  import oHomeTeacher from '@/components/APP/Campus/Home/TeacherHome';
  import oHeadTools from '@/components/APP/Campus/Assembly/HeadTools';

  export default {
    name: "applet_main_login", /* 这个name暂时不知道用啥用，根据官方文档说的是方便排错的 */
    data() {
      return {
        octopus: this.$parent.octopus,
        url: "",
        param: "",
        isApplet: "No",
        isLogin: false, // 登陆模式：未登陆：false；登陆：true；
        typeID: 2, //默认家长端
        progress: 0,
        debugModel: false, // 调试模式：关闭调试窗：false；开启：true；
        signatureSource: {},
      }
    },
    activated: function () {
      this.init();
      this.octopus.tips.debug("Login.vue执行了activated事件。");
    },
    components: {oHomeParent, oHomeTeacher, oHeadTools},
    methods: {
      init: function () {
        console.log("第三方登录开始执行");
        this.octopus.applet.setTitle("鉴权中心");
        let o = this;
        // 模拟进度条
        this.onProgress();
        // 获取当前打开的URL
        this.url = JSON.stringify(this.octopus.router.get().path);
        // 获取小程序传过来的各项参数
        this.param = this.octopus.router.get().query;
        // 小程序赋值
        if (this.param.username && this.param.timespan && this.param.password && this.param.bangs) {
          // this.octopus.passport.typeID = this.param["type"]; // 应该由账号本身判断是管理（教师）端，还是用户（家长）端
          this.octopus.passport.name = this.param["username"];
          this.octopus.passport.timespan = this.param["timespan"];
          this.octopus.passport.password = this.param["password"];
          this.octopus.passport.bangs = this.param["bangs"] == "1" ? true : false; //是否刘海
        }

        // 调试模式
        if (this.octopus.config.model == "debug") {
          // 启动调试面板
          this.debugModel = true;
        }
        // this.octopus.passport.bangs = false;
        // 三方平台登录：蓝鸽平台。
        if (this.param.code) {
          // alert(o.octopus.passport.bangs);
          if (this.param.lancooframe) {
            // 蓝鸽app统一展示刘海
            this.octopus.passport.bangs = true;
            console.warn("蓝鸽登陆成功。");
            this.octopus.request.localstorage.set("lancoo", {isLancoo: true});
            // 三方自动登录
            this.onLoginTripartite("lancoo", this.param.code);
          }
          //
          else {
            window.open("lancoologin?code=" + o.param.code, "_self");
          }
        }
        // 非蓝鸽平台登陆。
        else {
          this.octopus.request.localstorage.set("lancoo", {isLancoo: false});

          // 如果是小程序，则启动登陆
          this.octopus.tools.isApplet().then(res => {
            // res == true，表示为小程序
            if (res) {
              o.isApplet = "YES";
              // 如果有值才提示；
              if (!o.octopus.tools.IsNullOrEmpty(o.octopus.passport.typeID)
                && !o.octopus.tools.IsNullOrEmpty(o.octopus.passport.name)
                && !o.octopus.tools.IsNullOrEmpty(o.octopus.passport.timespan)
                && !o.octopus.tools.IsNullOrEmpty(o.octopus.passport.password)) {

                // o.octopus.tips.error("刘海：" + isBangs);
                o.onLogin();
              } else {
                o.octopus.tips.error("缺少参数，请重新访问。")
              }
            }
            // 异常报警
            else {
              // 此登陆模块仅支持 微信小程序 或 阿里小程序登陆使用。
              // o.octopus.tips.error("非小程序登陆，请在标准容器中打开。")
              console.error("非小程序登陆，请在标准容器中打开。")
            }
          });
        }
      },
      // 登陆
      onLogin: function () {
        let o = this;
        // 获取护照数据，不管成功与否，全部设置为true。
        this.octopus.request.security.passport.get(function (passport_data) {
          o.octopus.passport.encryption = true;
          if (!o.octopus.tools.IsNullOrEmpty(passport_data) && passport_data.status.code == 200) {
            o.octopus.request.security.token.get(function (token_data) {
              if (!o.octopus.tools.IsNullOrEmpty(token_data) && token_data.status.code == 200) {
                // 调试时打印获取到权限数据。
                // o.octopus.tips.success("Passport OK：" + JSON.stringify(passport_data));
                // o.octopus.tips.success("Token OK：" + JSON.stringify(token_data));

                // 初始化配置
                o.onConfig();
              } else {
                o.octopus.tips.error(token_data);
              }
            });
          } else {
            o.octopus.tips.error(passport_data);
          }
        });
      },
      // 三方自动登录
      onLoginTripartite: function (platform, data) {
        let o = this;
        // 发起请求
        if (platform == "lancoo") {
          this.octopus.tools.openAPI("/ESB/Tripartite/LanCoo/Login?code=" + data, {}, function (loginData) {
            // alert(JSON.stringify(loginData.content.content));
            if (loginData.status.code == 200 && loginData.content.status.code == 200) {
              o.octopus.passport.name = loginData.content.content.Name;
              o.octopus.passport.password = loginData.content.content.Password;
              // 更新时间戳（毫秒）
              o.octopus.passport.timespan = (new Date()).valueOf();
              o.octopus.passport.password = o.octopus.tools.md5(o.octopus.passport.name
                + "marco" + o.octopus.passport.timespan + "july" + o.octopus.passport.password);
              // 获取护照数据，不管成功与否，全部设置为true。
              o.octopus.request.security.passport.get(function (passport_data) {
                o.octopus.passport.encryption = true;
                if (!o.octopus.tools.IsNullOrEmpty(passport_data) && passport_data.status.code == 200) {
                  if (passport_data.content && passport_data.content.authorization && passport_data.content.authorization.project) {
                    o.octopus.request.security.token.get(function (token_data) {
                      if (!o.octopus.tools.IsNullOrEmpty(token_data) && token_data.status.code == 200) {
                        // 执行登录
                        o.onHome();
                      } else {
                        o.octopus.tips.error(token_data);
                      }
                    });
                  } else {
                    o.octopus.tips.error("请联系管理员分配正确的可访问权限");
                  }

                } else {
                  o.octopus.tips.error(passport_data);
                }

              });

            } else {
              // [130900] Code鉴权失败。
              o.octopus.tips.error(loginData.content);
            }
          });
        }
      },
      // 模拟提交，用于浏览器测试提交用。
      simulationLogin: function () {
        let Param = "?timespan=" + this.param["timespan"];
        Param += "&username=" + this.param["username"];
        Param += "&password=" + this.param["password"];
        Param += "&type=" + this.param["type"]; // 1:教师端（管理端）；2:家长端（用户端）；
        Param += "&bangs=" + this.param["bangs"]; // 是否刘海屏，底部预留空间：1:预留；0:不预留。
        this.octopus.router.jump("/main/app/campus/login" + Param);
      },
      // 初始化 小程序 配置，配置必须写在首页，写在内部页是不行的，因为目前八抓鱼是单页程序。
      onConfig: function () {
        let o = this;
        this.octopus.applet.config(['scanQRCode', 'getLocation', 'openLocation', 'chooseImage', 'getNetworkType'
          , 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareAppMessage', 'onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareQZone'], (res) => {
          if (res.status.code == 200) {
            // 成功
            // alert("wx.config: "+JSON.stringify(res));
            // o.octopus.applet.getPhoneVersion();
            // o.octopus.applet.postAppletMessage({name: "112233"});
            // o.octopus.applet.wxNavgateTo("pages/login/index");

            // 打印成功信息
            o.signatureSource = "API OK: " + JSON.stringify(res.content);

            // 加载首页相关数据
            o.onHome();
          } else {
            o.octopus.tips.error(res);
            o.signatureSource = "API ERROR: " + JSON.stringify(res);
          }

        }, (res) => {
          o.octopus.tips.error(res);
          // 失败
          o.signatureSource = "CONFIG ERROR: " + JSON.stringify(res);
        });
      },
      // 配置进度
      onProgress: function () {
        let o = this;

        if (o.progress < 100) {
          setTimeout(function () {
            // 进度模拟
            if (o.progress < 50) {
              o.progress += 5;
            } else {
              o.progress += 2;
            }

            // 最高 100%
            o.progress = o.progress > 100 ? 100 : o.progress;

            o.onProgress();
          }, 100);
        } else {
          // 完成后直接执行切换。
          this.isLogin = true;
          // 加载地图引擎，切记要在完全加载后，DOM呈现以后 再执行onMap，否则会因为加载不到DOM而报错，此处已由组件替代。
          // this.onMap();
          // this.octopus.router.jump("/APP/Campus/Home/Page");
        }
      },
      // 加载首页相关数据
      onHome: function () {
        if (this.octopus.passport.typeID == 2) {
          // 执行标题的变更
          this.octopus.applet.setTitle("首页 - 家长端");
          // 全部完成后变更进度条为 100，则 onProgress 的 this.isLogin 会变成 true。
        } else {
          this.octopus.applet.setTitle("首页 - 教师端");
        }
        // 全部完成后变更进度条为 100，则 onProgress 的 this.isLogin 会变成 true。
        this.progress = 100;
      },
      // 子控件回调主控件。
      onHomeComplete: function (value) {
        // this.octopus.tips.success(value);
      },
      getPhoto: function () {
        let o = this;
        this.octopus.applet.ability('chooseImage', {
          scene: '1|2',
          count: 9,  // 选取照片最多9张
          sizeType: ['original', 'compressed'],// 原图、压缩图
          sourceType: ['album', 'camera'] // 相册、相机
        }).then(async res => {
          o.signatureSource = JSON.stringify(res);
        }).catch(err => {
          o.signatureSource = JSON.stringify(err);
        });
      },
      getNetwork: function () {
        let o = this;
        this.octopus.applet.ability('getNetworkType', {}).then(async res => {
          o.signatureSource = JSON.stringify(res);
        }).catch(err => {
          o.signatureSource = JSON.stringify(err);
        });
      },
      getQRCode: function () {
        let o = this;
        this.octopus.applet.ability('scanQRCode', {
          needResult: 1,
          scanType: ['qrCode'],
        }).then(async res => {
          o.signatureSource = JSON.stringify(res);
        }).catch(err => {
          o.signatureSource = JSON.stringify(err);
        });
      },
      getLocation: function () {
        let o = this;
        this.octopus.applet.ability('getLocation', {
          type: 'wgs84',
        }).then(async (res) => {
          o.signatureSource = JSON.stringify(res);
        }).catch(err => {
          o.signatureSource = JSON.stringify(err);
        });
      },
      getNavigation: function () {
        let o = this;
        this.octopus.applet.ability('openLocation', {
          latitude: Number(121.479271), // 纬度，浮点数，范围为90 ~ -90
          longitude: Number(31.238784), // 经度，浮点数，范围为180 ~ -180。
          name: 'women', // 位置名
          address: 'hahaah', // 地址详情说明
          scale: 1, // 地图缩放级别,整型值,范围从1~28。默认为最大
          infoUrl: 'http://www.baidu.com' // 在查看位置界面底部显示的超链接,可点击跳转
        }).then(async res => {
          o.signatureSource = JSON.stringify(res);
        }).catch(err => {
          o.signatureSource = JSON.stringify(err);
        });
      },
      // 分享朋友圈
      // 文档：https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html#112
      getShare: function () {
        let o = this;
        this.octopus.applet.ability('updateTimelineShareData', {
          title: '111111', // 分享标题
          link: '22222', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: 'http://saas.aaa.com/sss/dds/aa.jpg', // 分享图标
        }).then(async res => {
          o.signatureSource = JSON.stringify(res);
        }).catch(err => {
          o.signatureSource = JSON.stringify(err);
        });
      },
      getQuit: function () {
        this.octopus.applet.logout();
      },
    },
    props: ["oData"]
  }
</script>



// WEBPACK FOOTER //
// src/components/Main/App/Campus/Login/Page.vue